import { saveAs } from "file-saver";

const escapeCsvCell = (value: any) => {
  const stringValue = String(value ?? "");
  if (/[",\n\r]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

interface ExportOverviewConversionsOptions {
  rows: any[];
  filename?: string;
}

const formatCvr = (value: any) => {
  const cvr = Number(value);
  if (Number.isNaN(cvr)) return "null";
  return parseFloat((cvr * 100).toFixed(2));
};

export const exportOverviewConversionsToCSV = ({
  rows,
  filename = "OverviewConversions",
}: ExportOverviewConversionsOptions) => {
  const columns = ["time_unit", "cvr"];
  const csvRows = [
    columns.map(escapeCsvCell).join(","),
    ...rows.map((row) =>
      columns
        .map((column) =>
          escapeCsvCell(
            column === "cvr" ? formatCvr(row?.cvr) : row?.[column] ?? "null",
          ),
        )
        .join(","),
    ),
  ];
  const blob = new Blob([csvRows.join("\n")], {
    type: "text/csv;charset=utf-8;",
  });
  saveAs(blob, `${filename}.csv`);
};
